/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of order. This can specify whether it's a regular purchase, subscription, etc.
 */
export const OrderType = {
  Recurring: "recurring",
  Onetime: "onetime",
} as const;
/**
 * The type of order. This can specify whether it's a regular purchase, subscription, etc.
 */
export type OrderType = ClosedEnum<typeof OrderType>;

/** @internal */
export const OrderType$inboundSchema: z.ZodNativeEnum<typeof OrderType> = z
  .nativeEnum(OrderType);
/** @internal */
export const OrderType$outboundSchema: z.ZodNativeEnum<typeof OrderType> =
  OrderType$inboundSchema;
